import { useChannelHealth } from '../../hooks/use-channels';
import { Badge } from '../ui/badge';
import { Skeleton } from '../ui/skeleton';

function pct(ratio: number | null | undefined): string {
  return ratio === null || ratio === undefined ? '—' : `${Math.round(ratio * 100)}%`;
}

export function ChannelHealthPanel({ channelId, onClose }: { channelId: string; onClose: () => void }) {
  const { data, isLoading, isError } = useChannelHealth(channelId);

  return (
    <aside className="flex w-96 shrink-0 flex-col gap-4 overflow-y-auto border-l border-border p-4 text-sm">
      <div className="flex items-center justify-between">
        <h2 className="font-semibold">Здоровье канала</h2>
        <button onClick={onClose} aria-label="Закрыть" className="text-muted-fg hover:text-fg">
          ✕
        </button>
      </div>

      {isLoading && (
        <div className="space-y-2">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      )}
      {isError && <div className="text-red-600">Не удалось загрузить данные о здоровье канала.</div>}

      {data && (
        <>
          <div>
            <div className="mb-1 text-xs font-medium text-muted-fg">Статус</div>
            <Badge tone={data.status === 'active' ? 'success' : data.status === 'restricted' ? 'danger' : 'neutral'}>
              {data.status}
            </Badge>
            {data.statusReason && <div className="mt-1 text-xs text-muted-fg">{data.statusReason}</div>}
          </div>

          <div>
            <div className="mb-1 text-xs font-medium text-muted-fg">Флуд-страйки</div>
            <span>{data.floodStrikes}</span>
          </div>

          <div>
            <div className="mb-1 text-xs font-medium text-muted-fg">Использование лимитов</div>
            <div className="space-y-1 rounded border border-border p-2 text-xs">
              {(['window', 'daily', 'weekly'] as const).map((key) => {
                const c = data.usage[key];
                if (!c) return null;
                return (
                  <div key={key} className="flex justify-between">
                    <span className="capitalize">{key}</span>
                    <span>
                      {c.used}/{c.max ?? '∞'} ({pct(c.ratio)})
                    </span>
                  </div>
                );
              })}
              {Boolean(data.usage.warmup) && (
                <Badge tone="warning" className="mt-1">
                  Warm-up активен
                </Badge>
              )}
            </div>
          </div>

          <div>
            <div className="mb-1 text-xs font-medium text-muted-fg">Инциденты (7 дней)</div>
            <span className="text-xs text-muted-fg">{data.incidents.last7Days.length} шт.</span>
          </div>
          <div>
            <div className="mb-1 text-xs font-medium text-muted-fg">Инциденты (30 дней)</div>
            <span className="text-xs text-muted-fg">{data.incidents.last30Days.length} шт.</span>
          </div>
        </>
      )}
    </aside>
  );
}
